export enum GaugeTypeEnum {
    High = 'High',
    Wide = 'Wide'
}